/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicPromptProfiling extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicPromptProfiling");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicPromptProfiling.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicPromptProfiling>): BackgroundJobPayloadForPeriodicPromptProfiling {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicPromptProfiling(), model);
        BackgroundJobPayloadForPeriodicPromptProfiling.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicPromptProfiling>): BackgroundJobPayloadForPeriodicPromptProfiling {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicPromptProfiling.newInstance(<BackgroundJobPayloadForPeriodicPromptProfiling> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicPromptProfiling) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicPromptProfiling.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicPromptProfiling): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicPromptProfiling.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
